import moment from 'moment';
import { getStringHidden } from '../../../views/ganttContainer/gantt/gantt.helper';
import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const startBaseCol = (gantt, t) => ({
  name: 'start_base',
  label: 'Inicio Base',
  align: 'center',
  resize: true,
  width: '70',
  template: (activity) => {
    let isOdd = false;
    if (gantt.oddColsConfig) {
      isOdd = gantt.oddColsConfig.start_base;
    }
    if (activity.baseline_points && activity.baseline_points.length) {
      const activeBaseline = activity.baseline_points.find((base) => {
        if (base.sectorbaselineversion) {
          if (base.sectorbaselineversion.active) {
            return true;
          }
        }
      });
      const last_baseline = activeBaseline;
      if (last_baseline) {
        activity.start_base = last_baseline.start_date;

        const hasChild = gantt.hasChild(activity.id);
        const momentDate = moment(last_baseline.start_date);
        const momentDateStr = momentDate
          .format(gantt.currentDateFormat)
          .toString();
        const htmlH = getStringHidden(momentDateStr, 'start_base');
        return `
                        <div class="${isOdd ? 'odd-col' : 'non-odd-col'}" style="${hasChild ? 'font-weight: 600' : 'font-weight: 100'}; 
                        color: #121212;">
                            <span class="string-v">${momentDate.format(gantt.currentDateFormat)}</span>
                            ${htmlH}
                        </div>
                        `;
      }
    } else {
      return `
                <div class="${isOdd ? 'odd-col' : 'non-odd-col'}">
                </div>
                `;
    }
  },
  hide: !isColumnVisibleByDefault('start_base'),
  data_type: 'date',
  groupable: false,
  orderable: true,
  orderable_switch: ['1 → N', 'N → 1'],
  filterable: true
});

export default startBaseCol;